import { track } from '../../analytics/helpers';
import * as types from './keys';

type Trait = { [key: string]: string };

export const trackCreateUserGeneratedContentClick = (traits?: Trait) => {
  track(types.SUBMIT_CREATE_USER_GENERATED_CONTENT_CLICK, traits);
};

export const trackCreateUserGeneratedContentCancel = (traits?: Trait) => {
  track(types.SUBMIT_CREATE_USER_GENERATED_CONTENT_CANCEL_CLICK, traits);
};
